// removed by extract-text-webpack-plugin
module.exports = {"MediaSection__caption":"MediaSection__caption","mediaSectionCaption":"MediaSection__caption","MediaSection__caption__label":"MediaSection__caption__label","mediaSectionCaptionLabel":"MediaSection__caption__label","MediaSection__caption__text":"MediaSection__caption__text","mediaSectionCaptionText":"MediaSection__caption__text","MediaSection__image":"MediaSection__image","mediaSectionImage":"MediaSection__image","MediaSection__native-video":"MediaSection__native-video","mediaSectionNativeVideo":"MediaSection__native-video"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/MediaSection.scss
// module id = 209
// module chunks = 0